import { render, staticRenderFns } from "./HotelPassengerCard.vue?vue&type=template&id=4f129706&scoped=true"
import script from "./HotelPassengerCard.vue?vue&type=script&lang=js"
export * from "./HotelPassengerCard.vue?vue&type=script&lang=js"
import style0 from "./HotelPassengerCard.vue?vue&type=style&index=0&id=4f129706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f129706",
  null
  
)

export default component.exports